import styled from 'styled-components';
import { COLORS } from 'modules/core/theme/colors';

export const CheckboxGroupUI = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
`;

export const CheckBox = styled.div`
  padding-right: 20px;
`;

export const Label = styled.label`
  display: contents;
  cursor: pointer;
`;

export const Input = styled.input`
  margin-right: 4px;
  margin-top: 2px;
  cursor: pointer;

  &:checked {
    background-color: ${COLORS.GREY_24};
    border-color: ${COLORS.GREY_24};
    color: black;
  }

  &:active {
    outline: none;
  }

  &:focus {
    outline: none;
    box-shadow: none;
    border-color: 1px solid ${COLORS.GREY_24};
  }
`;
